import React from 'react';
import createSvgIcon from '../utils/create-svg-icon';
import { jsx as _jsx } from "react/jsx-runtime";
var ChevronUp = createSvgIcon({
  path: [/*#__PURE__*/_jsx("path", {
    d: "M25.7071 20.2049C25.3166 20.5984 24.6834 20.5984 24.2929 20.2049L16 11.8412L7.70711 20.2049C7.31658 20.5984 6.68342 20.5984 6.29289 20.2049C5.90237 19.8114 5.90237 19.1735 6.29289 18.7801L16 9L25.7071 18.7801C26.0976 19.1735 26.0976 19.8114 25.7071 20.2049Z",
    fill: "#050038"
  }, "0")],
  rect: [],
  displayName: 'ChevronUp',
  viewBox: '0 0 32 32'
});
export default ChevronUp;